import React from 'react';
import PropTypes from 'prop-types';

import { ArrowLeftSVG, ArrowRightSVG } from '../../../Iconography';

import {
  arrow,
  arrowSmall,
  arrowBtnNext,
  arrowBtnPrev,
} from './styles.module.css';

const arrowPropTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  small: PropTypes.bool,
};

const arrowDefaultProps = {
  className: '',
  onClick: () => {},
  small: false,
};

export const NextArrow = ({ onClick, className, small }) => (
  <button className={[arrowBtnNext, className].join(' ')} onClick={onClick}>
    <ArrowRightSVG className={`${small ? arrowSmall : arrow}`} />
  </button>
);

NextArrow.propTypes = arrowPropTypes;
NextArrow.defaultProps = arrowDefaultProps;

export const PrevArrow = ({ onClick, className, small }) => (
  <button className={[arrowBtnPrev, className].join(' ')} onClick={onClick}>
    <ArrowLeftSVG className={`${small ? arrowSmall : arrow}`} />
  </button>
);

PrevArrow.propTypes = arrowPropTypes;
PrevArrow.defaultProps = arrowDefaultProps;
